import React from "react";
import "./RealtyGridSmall.css";
import { FaMapMarkerAlt } from "react-icons/fa";

import ShopFull from "../ShopFull.jpeg";
import shop1 from "../shop1.jpeg";
import shop from "../shop.jpeg";

const images = [
  { url: ShopFull, title: "" },
  { url: shop1, title: "" },
  { url: shop, title: "" },
];

const location =
  "https://www.google.com/maps/place/14%C2%B009'57.3%22N+77%C2%B048'41.2%22E/@14.1659222,77.808857,17z";

const RealtyGridSmall = () => {
  return (
    <div className="small-grid-section">
      {/* Heading with inline location icon */}
      <h2 className="small-grid-title">
        <a
          href={location}
          target="_blank"
          rel="noopener noreferrer"
          className="marker-inline"
        >
          <FaMapMarkerAlt className="map-icon" />
        </a>
        Visit Our Office
      </h2>

      <div className="small-grid-container">
        {images.map((item, index) => (
          <div className="small-grid-item" key={index}>
            <img src={item.url} alt={item.title} />
            <div className="grid-overlay">
              <h4>{item.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RealtyGridSmall;